<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-company-calendar-presenter
[companyDates] = 'companyDates$ | async'
[userInfo]="userInfo$ | async"
(SaveEvent)="onSaveEvent($event)"
(LoadAllDates)="onLoadAllDates()"
(LoadDates)="onLoadDates($event)"
(DeleteEvent)="onDeleteEvent($event)"
[events]="events"
>
</ef-company-calendar-presenter>
